<template>
<div>
  <router-view></router-view>
  <Loading v-show="loading"></Loading>
</div>
</template>

<script>
import Loading from "./components/loading/Modal.vue";
import { bus } from './main';
import { mapActions } from "vuex";

export default {
  name: 'App',
  components:{
    Loading
  },
  data() {
    return {
      loading:false,
      url:''
    }
  },
  created() {
    bus.$on('loading', (data) => {
      this.loading = data;
    });
    // this.mtdCheckSession();
  },
  methods: {
    ...mapActions(["get", "post"]),
    mtdCheckSession: function () {
      this.get({
        url: this.$store.getters.get__url + "/user/check",
        params: this.login,
      })
        .then((response) => {
          // console.log(response);
        })
        .catch((errors) => {
          // this.errorsBackend = errors;
          // this.$emit("error", this.event);
        });
    },
  }, 
}
</script>

<style lang="scss">
  // Import Main styles for this application
  @import 'assets/scss/style';
</style>
